import { Injectable } from "@angular/core";

import { Capacitor } from "@capacitor/core";
import { Securekey } from "secure-key-plugin";

@Injectable({ providedIn: "root" })
export class NativeTestService {
  async testPlugin() {
    try {
      const platform = Capacitor.getPlatform();
      //  console.log('Platform:', platform);

      //   console.log('1️⃣ Deleting old key from KeyStore...');
      await Securekey.deleteKeyPair();
      //   console.log('✅ Old key deleted');

      // 3. Verify key is gone
      //  console.log('3️⃣ Verifying key deletion...');
      const check = await Securekey.hasKeyPair();
      if (check.exists) {
        throw new Error("Key still exists after deletion!");
      }
      //   console.log('✅ Key confirmed deleted');
      // Generate key pair
      /*  const result = await Securekey.generateKeyPair();
    console.log('Public Key:', result.publicKeySpki);

    // Check if key exists
    const hasKey = await Securekey.hasKeyPair();
    console.log('Has key:', hasKey.exists);

    // Decrypt (example)
    const decrypted = await Securekey.decrypt({
      ciphertext: 'base64EncodedCiphertext...'
    });
    console.log('Decrypted:', decrypted.plaintext);*/
    } catch (error) {
      console.error("Plugin error:", error);
    }
  }
}
